(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningPathVersionStorefrontCrossSellResource", ["$resource", learningPathVersionStorefrontCrossSellResource]);
    function learningPathVersionStorefrontCrossSellResource($resource) {
        return $resource("/api/learningPathVersionStorefront/:number/:version/crossSell/:action/:value", { number: "@number", version: "@version", value: "@value" }, {
            getStorefrontCrossSellList: {
                method: "GET"
            },
            removeCrossSellItem: {
                method: "DELETE",
                params: {
                    action: "remove"
                }
            },
            addCrossSellItem: {
                method: "POST",
                params: {
                    action: "add"
                }
            }
        });
    }
}());
